import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface QuickRange {
  key: string;
  label: string;
  fromDays?: number;
  toDays?: number;
  computeDates?: () => { from: Date; to: Date };
}

export interface QuickRangeEvent {
  key: string;
  from: Date;
  to: Date;
}

@Component({
  selector: 'app-date-quick-chips',
  templateUrl: './date-quick-chips.component.html',
  styleUrls: ['./date-quick-chips.component.scss'],
})
export class DateQuickChipsComponent {
  @Input() activeKey: string | null = null;
  @Output() rangeSelected = new EventEmitter<QuickRangeEvent>();

  readonly ranges: QuickRange[] = [
    { key: 'ty', label: 'This year', computeDates: () => {
        const y = new Date().getFullYear();
        return { from: new Date(y, 0, 1, 0, 0, 0, 0), to: new Date(y, 11, 31, 23, 59, 59, 999) };
      }
    },
    { key: 'tm', label: 'This month', computeDates: () => {
        const n = new Date();
        return {
          from: new Date(n.getFullYear(), n.getMonth(), 1, 0, 0, 0, 0),
          to: new Date(n.getFullYear(), n.getMonth() + 1, 0, 23, 59, 59, 999),
        };
      }
    },
    { key: 'td', label: 'Today',        fromDays: 0,  toDays: 0  },
    { key: 'ld', label: 'Last day',     fromDays: 1,  toDays: 0  },
    { key: 'yd', label: 'Yesterday',    fromDays: 1,  toDays: 1  },
    { key: '3d', label: 'Last 3 days',  fromDays: 3,  toDays: 0  },
    { key: '1w', label: 'Last week',    fromDays: 7,  toDays: 0  },
    { key: '2w', label: 'Last 2 weeks', fromDays: 14, toDays: 0  },
    { key: '1m', label: 'Last month',   fromDays: 30, toDays: 0  },
  ];

  select(range: QuickRange): void {
    let from: Date;
    let to: Date;
    if (range.computeDates) {
      ({ from, to } = range.computeDates());
    } else {
      const today = new Date();
      from = new Date(today);
      from.setDate(today.getDate() - (range.fromDays ?? 0));
      from.setHours(0, 0, 0, 0);
      to = new Date(today);
      to.setDate(today.getDate() - (range.toDays ?? 0));
      to.setHours(23, 59, 59, 999);
    }
    this.activeKey = range.key;
    this.rangeSelected.emit({ key: range.key, from, to });
  }
}
